export default __webpack_public_path__ + "static/media/No85Open.fef73ff8.jpg";